import React from 'react';
import { Modal } from "antd";
import DetalheVeiculo from '../../detalheVeiculo';

export default function ModalDetalheVeiculo({ exibirModal, fecharModal, dadosModal }) {

    return (
        <Modal
            open={exibirModal}
            destroyOnClose
            title="Detalhes do Veículo"
            width="70%"
            onCancel={() => fecharModal()}
            footer={null}
        >
            <DetalheVeiculo dadosModal={dadosModal} />
        </Modal>
    );
}
